import React from 'react';
import { useTranslation } from 'react-i18next';
import '../styles/print-institutional.css';
import { DashboardSidebar, DashboardContent } from '../components/ui/dashboard-sidebar';
import HelpCenter from '../components/help/HelpCenter';
import { useAdminDashboard } from './AdminDashboardHooks';
import { AdminDashboardHeaderBar, AdminDashboardStats } from './AdminDashboardHeader';
import AdminDashboardTabs from './AdminDashboardTabs';

export default function AdminDashboard() {
  const { t } = useTranslation();
  const {
    user, getAuthHeader, navigate,
    stats, coopers, loading, activeTab, setActiveTab,
    handleValidateCooper, handleLogout, isSuperAdmin, sidebarTabs,
  } = useAdminDashboard();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-coppam-gold"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-slate-50" data-print-mode="institutional">
      <AdminDashboardHeaderBar t={t} user={user} handleLogout={handleLogout} />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 print-area">
        <AdminDashboardStats
          t={t}
          stats={stats}
          isSuperAdmin={isSuperAdmin}
          navigate={navigate}
          setActiveTab={setActiveTab}
        />

        {/* Main Content with Sidebar */}
        <div className="flex gap-4 md:gap-6">
          <DashboardSidebar
            tabs={sidebarTabs}
            activeTab={activeTab}
            onTabChange={setActiveTab}
            className="no-print"
          />

          <DashboardContent className="space-y-4">
            <AdminDashboardTabs
              activeTab={activeTab}
              user={user}
              getAuthHeader={getAuthHeader}
              isSuperAdmin={isSuperAdmin}
              t={t}
              navigate={navigate}
              coopers={coopers}
              handleValidateCooper={handleValidateCooper}
            />
          </DashboardContent>
        </div>

        {/* Legal Notice Footer */}
        <div className="mt-8 bg-slate-100 p-4 rounded-lg">
          <p className="text-xs text-slate-600 leading-relaxed">
            Les garanties solidaires relèvent exclusivement du champ de l'entraide associative.
            Elle ne constitue ni une assurance, ni un convention d'indemnisation au sens du Code des assurances.
            Elle est conforme : – à la jurisprudence du Conseil d'État, 10 février 1984 (Association d'entraide des transporteurs routiers) ;
            – à la doctrine ACPR 2019 & 2022, reconnaissant les dispositifs de solidarité non contractuels ;
            – et à la loi du 31 juillet 2014 relative à l'économie sociale et solidaire ; et la loi coopérative de 1947.
          </p>
        </div>
      </div>

      {/* Centre d'aide HIGH-TECH */}
      <HelpCenter space="admin" user={user} />
    </div>
  );
}
